import { HorizontalContainer } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DropdownMenuItemContainer: FunctionComponent<Props> = ({
    children,
    className = '',
    isActive = false,
    onClick,
    testId = TEST_ID
}) => {
    const activeStyles = isActive ? styles.active : '';

    return (
        <HorizontalContainer
            className={`${className} ${styles.dropdownMenuItemContainer} ${activeStyles}`}
            onClick={onClick}
            testId={testId}>
            {children}
        </HorizontalContainer>
    );
};

export default DropdownMenuItemContainer;
